import moment from 'moment';
import React from 'react';
import { CaptionPropTypes } from 'react-day-picker';

const Caption = function({ date }) {
  const dateMoment = moment(date);

  return (
    <div className='DayPicker-Caption'>
      <span className='calendar__caption__month'>{ dateMoment.format('MMM') } </span>{ dateMoment.format('YYYY') }
    </div>
  );
};

Caption.propTypes = CaptionPropTypes;

export default Caption;



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_Caption.jsx